import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { GuestExperienceTextMessagingContainer } from '@mews-commander/modules/src/modules/guestExperienceTextMessaging';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { OwnerId } = Route.useSearch();
    const guideLink = createGuideLink(ArticlePath.SMSPackageForMewsOperations);

    return <GuestExperienceTextMessagingContainer guideLink={guideLink} ownerId={OwnerId} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/GuestExperience/TextMessaging')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    component: Component,
    staticData: {
        routeName: RouteName.TextMessaging,
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
        title: TextKey.TextMessaging,
    },
});
